import {
  CARD_ERROR_SEVERITIES,
  senderCardStatuses,
} from "tng-address-collection-shared/cardStatuses.ts";
import { normalizeDuplicateName } from "tng-address-collection-shared/normalizeDuplicateName.ts";
import {
  CardErrorType,
  CardsListItem,
} from "tng-address-collection-shared/types/apiTypes.ts";

export const duplicatedNamesOf = (
  cards: Pick<CardsListItem, "firstName" | "lastName">[],
): Set<string> => {
  const occurrences = new Map<string, number>();
  for (const { firstName, lastName } of cards) {
    const name = normalizeDuplicateName(firstName, lastName);
    occurrences.set(name, (occurrences.get(name) ?? 0) + 1);
  }
  return new Set(
    [...occurrences].filter(([, count]) => count > 1).map(([name]) => name),
  );
};

export const cardStatusesOf = (
  card: CardsListItem,
  hiddenFields: string[],
  duplicatedNames?: ReadonlySet<string>,
): CardErrorType[] => [
  ...senderCardStatuses({
    senderId: card.senderId,
    senderUnknown: card.senderUnknown,
    manualDispatch: card.manualDispatch,
    signatureUidNumbers: hiddenFields.includes("signatures")
      ? undefined
      : card.signatures?.map(({ uidNumber }) => uidNumber),
  }),
  ...(card.hasContactDetailsWarning
    ? (["contactDetailsInconsistent"] as const)
    : []),
  ...(duplicatedNames?.has(
    normalizeDuplicateName(card.firstName, card.lastName),
  )
    ? (["duplicateName"] as const)
    : []),
];

export const hasErrorStatus = (statuses: CardErrorType[]): boolean =>
  statuses.some((status) => CARD_ERROR_SEVERITIES[status] === "error");

export const statusSortRank = (
  card: CardsListItem,
  hiddenFields: string[],
  duplicatedNames?: ReadonlySet<string>,
): number => {
  const statuses = cardStatusesOf(card, hiddenFields, duplicatedNames);
  if (statuses.length === 0) return 2;
  return hasErrorStatus(statuses) ? 0 : 1;
};
